import React, { useState } from 'react';
import { useDrag } from 'react-dnd';
import { MdClose } from 'react-icons/md';

const DraggableRiskCard = ({ control, index = 0, onRemove }) => {
  // Be robust to various AI field names
  const data = control || {};
  const title =
    data.title ??
    data.riskTitle ??
    data.name ??
    data.Title ??
    data.summary ??
    '(no title)';

  const [{ isDragging }, dragRef] = useDrag(() => ({
    type: 'RISK',                      // avoid colliding with CONTROL DnD type
    item: () => ({ index, control: data, id: data.id }),
    collect: (monitor) => ({
      isDragging: !!monitor.isDragging(),
    }),
  }));

  const [isHovered, setIsHovered] = useState(false);

  const handleMouseDown = (e) => e.stopPropagation();

  //console.log('DraggableRisk props:', data);

  return (
    <div
      ref={dragRef}
      onMouseDown={handleMouseDown}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      className={`relative control-card shadow p-3 mb-2 rounded bg-white bg-opacity-70 backdrop-blur-md border border-gray-300 transition-all duration-300 ease-in-out ${
        isDragging ? 'opacity-50' : ''
      }`}
      style={{
        transform: `translateY(${Number.isFinite(index) ? index * 10 : 0}px)`,
        boxShadow: isHovered ? '0px 8px 20px rgba(0, 0, 0, 0.3)' : 'none',
        cursor: 'pointer',
        opacity: isHovered ? 1 : 0.9,
        transition: 'all 0.3s ease',
      }}
    >
      <MdClose
        className="absolute top-1 right-1 text-gray-500 hover:text-red-600 cursor-pointer"
        size={20}
        onClick={(e) => {
          e.stopPropagation();
          onRemove?.(data.id);
        }}
      />
      <p className="font-medium leading-snug">{title}</p>
      {data.definition && (
        <p className="text-xs text-gray-600 mt-1 line-clamp-3">{data.definition}</p>
      )}
      {data.trend && (
        <div className="flex items-center mt-1">
          {data.trend === "growing" && (
            <svg
              className="w-4 h-4 text-green-600 animate-bounce"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              viewBox="0 0 24 24"
            >
              <path strokeLinecap="round" strokeLinejoin="round" d="M5 12l5-5 5 5M5 19h14" />
            </svg>
          )}

          {data.trend === "same" && (
            <svg
              className="w-4 h-4 text-gray-500"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              viewBox="0 0 24 24"
            >
              <path strokeLinecap="round" strokeLinejoin="round" d="M5 12h14" />
            </svg>
          )}

          {data.trend === "decreasing" && (
            <svg
              className="w-4 h-4 text-red-600 animate-bounce"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              viewBox="0 0 24 24"
            >
              <path strokeLinecap="round" strokeLinejoin="round" d="M19 12l-5 5-5-5M5 5h14" />
            </svg>
          )}

          <span className="text-xs text-gray-600 ml-1 capitalize">{data.trend}</span>
        </div>
      )}
    </div>
  );
};

export default DraggableRiskCard;